var map = {
	"./building-active.svg": 13153,
	"./data-active.svg": 88885,
	"./leader-active.svg": 2008,
	"./note-active.svg": 2905,
	"./process-active.svg": 93040,
	"./profile2user-active.svg": 75839,
	"./ranking-active.svg": 68255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33909;